import { MarsbetLoading } from "@pages/casino/assets/icons";
import { ZenginsinLoader } from "@pages/casino/components";
import TabLoading from "@pages/casino/components/TabSkeleton/index.jsx";
import React, { useEffect } from "react";
import { Translate } from "react-localize-redux";
import styled from "styled-components";
import ChokwinLoading from "./chokwinLoading.js";

export const EXPANDED_LOADING = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 30px;
	text-align: center;
	color: var(--main-text-color);
	font-size: 26px;
	font-weight: 700;
	letter-spacing: 0.78px;
	text-transform: uppercase;
	.loading-img {
		width: 64px;
	}
`;
EXPANDED_LOADING.displayName = "EXPANDED_LOADING";

const EXCLUDED_PATHS = ["/casino", "/provider", "/casino-favorites"];
const EXCLUDED_MARS_PATHS = [...EXCLUDED_PATHS, "/docs", "/profile"];

const StandardLoading = ({ width }) => (
	<img
		width={width}
		src="/loading.gif"
		alt="loading"
	/>
);

const GannarExpandedLoading = ({ translate }) => (
	<EXPANDED_LOADING>
		<div style={{ width: "130px", height: "135px" }}>
			<img src="/loading_up.png" />
		</div>
		{window.SHOW_EXPANDED_LOADING_TEXT &&
			translate("WELCOME_TO", {
				tenantName: translate(window.TENANT?.toUpperCase()),
			})}
		<img
			className="loading-img"
			src="/generic_loading.gif"
			alt="Loading"
		/>
	</EXPANDED_LOADING>
);

const MarsExpandedLoading = ({ translate }) => (
	<EXPANDED_LOADING>
		<MarsbetLoading />
		{window.SHOW_EXPANDED_LOADING_TEXT &&
			translate("WELCOME_TO", {
				tenantName: translate(window.TENANT?.toUpperCase()),
			})}
		<img
			className="loading-img"
			src="/generic_loading.gif"
		/>
	</EXPANDED_LOADING>
);

const LuckykingbetExpandedLoading = ({ translate }) => (
	<EXPANDED_LOADING>
		<div style={{ width: "130px", height: "130px" }}>
			<img
				style={{ width: "130px", height: "130px" }}
				src="/loading_up.png"
			/>
		</div>
		<div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
			<span>{translate("WELCOME")}</span>
			<span>{translate(window.TENANT?.toUpperCase())}</span>
		</div>
		<img
			className="loading-img"
			src="/generic_loading.gif"
		/>
	</EXPANDED_LOADING>
);

const NoveroExpandedLoading = ({ translate }) => (
	<EXPANDED_LOADING>
		<div style={{ width: "130px", height: "130px" }}>
			<img
				style={{ width: "130px", height: "130px" }}
				src="/loading_up.png"
			/>
		</div>
		{window.SHOW_EXPANDED_LOADING_TEXT && (
			<div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
				<span>{translate("WELCOME")}</span>
				<span>{translate(window.TENANT?.toUpperCase())}</span>
			</div>
		)}
		<img
			className="loading-img"
			src="/generic_loading.gif"
		/>
	</EXPANDED_LOADING>
);

const DefaultExpandedLoading = ({ translate }) => (
	<EXPANDED_LOADING>
		<div style={{ width: "130px", height: "135px" }}>
			{window.TENANT === "zenginsin" ? (
				<ZenginsinLoader />
			) : (
				<img
					style={{ width: "130px", height: "135px" }}
					src="/loading_up.png"
				/>
			)}
		</div>
		{window.SHOW_EXPANDED_LOADING_TEXT &&
			translate("WELCOME_TO", {
				tenantName: translate(window.TENANT?.toUpperCase()),
			})}
		{window.TENANT !== "oddsfusion" && (
			<img
				className="loading-img"
				src="/generic_loading.gif"
			/>
		)}
	</EXPANDED_LOADING>
);

export default function CommonLoading({ expanded = true, width = 64 }) {
	const [loading, setLoading] = React.useState(true);

	useEffect(() => {
		const body = document.querySelector("body");
		body.style.overflow = "hidden";
		return () => {
			body.style.overflow = "auto";
			setLoading(false);
		};
	}, []);

	if (window.TENANT === "chokwin") {
		return <ChokwinLoading />;
	}

	const renderLoadingContent = (translate) => {
		const currentPath = window.location.pathname;

		if (window.HAS_GANNAR_LOADING) {
			if (EXCLUDED_MARS_PATHS.some((path) => currentPath.includes(path))) {
				return <TabLoading loading={loading} />;
			} else {
				return <GannarExpandedLoading translate={translate} />;
			}
		}

		if (window.HAS_MARS_LOADING && window.TENANT === "novero") {
			if (EXCLUDED_MARS_PATHS.some((path) => currentPath.includes(path))) {
				return <TabLoading loading={loading} />;
			}
			return <NoveroExpandedLoading translate={translate} />;
		}

		if (
			window.HAS_MARS_LOADING &&
			window.TENANT !== "luckykingbet" &&
			window.TENANT !== "novero"
		) {
			if (EXCLUDED_MARS_PATHS.some((path) => currentPath.includes(path))) {
				return <TabLoading loading={loading} />;
			}
			return expanded && window.EXPANDED_LOADING ? (
				<MarsExpandedLoading translate={translate} />
			) : (
				<MarsbetLoading />
			);
		}

		if (window.HAS_MARS_LOADING && window.TENANT === "luckykingbet") {
			if (EXCLUDED_MARS_PATHS.some((path) => currentPath.includes(path))) {
				return <TabLoading loading={loading} />;
			}
			return <LuckykingbetExpandedLoading translate={translate} />;
		}

		if (EXCLUDED_PATHS.some((path) => currentPath.includes(path))) {
			return <TabLoading loading={loading} />;
		}

		return expanded && window.EXPANDED_LOADING ? (
			<DefaultExpandedLoading translate={translate} />
		) : (
			<StandardLoading width={width} />
		);
	};

	return (
		<Translate>
			{({ translate }) => (
				<div className="loading-wrapper">{renderLoadingContent(translate)}</div>
			)}
		</Translate>
	);
}
